import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../axiosAuth";
import { DOCUMENT_TYPE_CONFIG_BY_COMMUNITY } from "./apiRoutes";

const mutateUpdateDocumentType = async ({
  id,
  data,
}: {
  id: string;
  data: FieldValues;
}) => {
  return await axiosAuth.put(
    `${DOCUMENT_TYPE_CONFIG_BY_COMMUNITY(data?.communityId)}/${id}`,
    data
  );
};

const useUpdateDocumentTypeMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      id: string;
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateUpdateDocumentType,
    ...queryParams,
  });

export default useUpdateDocumentTypeMutation;
